import React from 'react';
import { Link } from 'gatsby';

const Footer = ({ className = '' }) => {
  return (
    <div className={`bg-aim-dark-background ${className}`}>
      <footer className="relative p-10 md:p-20 pb-0 md:pb-5 text-white z-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-y-10 lg:gap-x-5">
          <div className="col-span-2 my-10 md:my-0">
            <img className="h-8" src="/images/aim-logo_light.svg" />
          </div>
          <div className="information">
            <p className="fs-psmall text-aim-accent mb-3 lg:mb-6">Information</p>
            <ul className="">
              <li className="mb-3 lg:mb-5">
                <Link to="/about/about-us">About Us</Link>
              </li>
              <li className="mb-3 lg:mb-5">
                <Link to="/about/faq">FAQs</Link>
              </li>
              <li className="mb-3 lg:mb-5">
                <Link to="/about/why-dm">Why DM?</Link>
              </li>
              <li className="mb-3 lg:mb-5">
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div className="resources">
            <p className="fs-psmall text-aim-accent mb-3 lg:mb-6">Resources</p>
            <ul className="">
              <li className="mb-3 lg:mb-5">
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li className="mb-3 lg:mb-5">
                <Link to="/environmental-policy">Environmental Policy</Link>
              </li>
              <li className="mb-3 lg:mb-5">
                <Link to="/terms-conditions">Terms & Conditions</Link>
              </li>
              <li className="mb-3 lg:mb-5">
                <Link to="/cookie-policy">Cookie Policy</Link>
              </li>
            </ul>
          </div>
          <div className="accreditations">
            <p className="fs-psmall text-aim-accent mb-3 lg:mb-6">Accreditations</p>
            <div className="flex items-center lg:inline">
              <img
                className="inline mr-3 h-10 lg:h-12"
                src="/images/cfa-ukas.png"
                alt="CFA UKAS Logo"
              />
              <img className="inline mr-3 mt-2 h-10 lg:h-12" src="/images/dma.png" alt="DMA Logo" />
              <img
                className="inline mt-2 mr-3 h-10 lg:h-12"
                src="/images/jic-mail-logo.png"
                alt="JIC Mail Logo"
              />
              <img
                className="inline mt-2 h-10 lg:h-12"
                src="/images/cyber-essentials-seek-logo.svg"
                alt="Cyber Essentials Logo"
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 pt-5 mt-5">
          <span className="col-span-1 text-left mb-4 lg:mb-0 pt-6 order-two lg:order-first">
            © {new Date().getFullYear()} Address Intelligence
          </span>
          <div className="col-span-1"></div>
          <div className="col-span-3 lg:col-start-3 border-t-2 pt-6 text-left order-first lg:order-two">
            Registered in England with Company Number 10401742.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
